

export const Colors={
    brand:{
        dark:"#203764",
        light:"#1890FF",
        tripper:"#EFF6FB",
        gray:'#383838',
        red:"#ed1d24",
        yellow:"#ffcb05",
        blue:"#0e3961",
        lightBlue:"#3dc2ff",
        lightRed:"#FF6359",
        background:"#ccc",
        green:"#00B050",
        black: '#000',
        white: '#fff',
        lightGray:"lightgray",
        orange:"orange"
    }
}